module.exports = __webpack_public_path__ + "assets/img/gift-title-back.7a3a50b4.png";